"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeComponent = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var syntax_highlighter_1 = require("../../syntax-highlighter");
var CodeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CodeComponent, _super);
    function CodeComponent(props) {
        var _this = _super.call(this, props) || this;
        syntax_highlighter_1.initializeSyntaxHighlights();
        return _this;
    }
    CodeComponent.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", { className: 'component code-component', "data-component-type": 'code' },
            React.createElement("div", { className: 'code-container', "data-language": props.value.language },
                React.createElement(syntax_highlighter_1.SyntaxHighlighter, { codeTagProps: { className: 'code' }, language: props.value.language, wrapLines: props.value.lineWrapping, style: syntax_highlighter_1.getSyntaxHighlightStyle(), showLineNumbers: true }, props.value.code))));
    };
    return CodeComponent;
}(React.PureComponent));
exports.CodeComponent = CodeComponent;
//# sourceMappingURL=code-component.comp.js.map